import Vue from 'vue';
import VueI18Next from '@panter/vue-i18next';
import i18next from 'i18next';
import resources from './locales';
import COLORS from '../../sass/basic/_colors.scss';
import COLORS_RTL from '../../sass/rtl/_colors.scss';
import { saveAs } from 'file-saver';

Vue.use(VueI18Next);

Vue.mixin({
  methods: {
    $_t(key, obj) {
      return this.$i18n.i18next.t(key, obj);
    },
    downloadFileUsingURL(url, filename = null) {
      if (filename) {
        saveAs(url, filename);
      } else {
        saveAs(url);
      }
    },
  },
});

let language = process.env.MIX_IS_HADAF || window.location.hostname.includes('hadafbeiyun.org') || window.location.hostname.includes('hadafbeiyun.test') ? 'heb' : 'en';

Vue.mixin({
  data: function () {
    return {
      get SITE_COLORS() {
        return language == 'heb' ? COLORS_RTL : COLORS;
      },
      get isRTL() {
        return language == 'heb';
      },
    };
  },
});

i18next.init({
  lng: language,
  fallbackLng: language,
  resources,
  parseMissingKeyHandler: function (key) {
    console.log('Invalid Key', key);
    return 'Invalid i18n Key';
  },
  interpolation: {
    format: function (value, format) {
      if (format === 'uppercase') return value.toUpperCase();
      if (format === 'lowercase') return value.toLowerCase();
      return value;
    },
    escapeValue: false
  },
});

export default new VueI18Next(i18next);
